import React, { useContext, useState, useEffect } from "react";
import { MdCheck, MdSchedule } from "react-icons/md";
import { doc, onSnapshot } from "firebase/firestore";
import moment from "moment"

import {AuthContext} from '../services/Session/Context'
import {FirebaseContext} from '../services/Firebase/Context'

const TimelineItem = ({ title, date, desc, userId, active, ended }) => {
  const { db } = useContext(FirebaseContext)
  const { user: authUser } = useContext(AuthContext)
  const [user, setUser] = useState({})

  useEffect(() => {
    if(!authUser) {
      return
    }
    const userSub = onSnapshot(doc(db, "users", userId), (doc) => setUser({id: doc.id, ...doc.data()}));
    return () => userSub()
  }, [db, userId, authUser])

  return (
    <div className="flex md:contents">
      <div className="col-start-1 col-end-2 mr-10 md:mx-auto relative">
        <div className="h-full w-6 flex items-center justify-center">
          <div className="h-full w-0.5 bg-gray-300 pointer-events-none"></div>
        </div>
        <div className={`w-6 h-6 absolute top-1/2 -mt-3 rounded-full
          ${!active || ended ? 'bg-green-500' : 'bg-gray-200 text-gray-600'} shadow`}
        >
          {
            active && !ended
            ? <MdSchedule className='w-full h-full p-1' />
            : <MdCheck className='w-full h-full p-1' />
          }
        </div>
      </div>
      <div className="bg-transparent col-start-2 col-end-12 p-4 rounded-xl my-4 mr-auto text-black w-full">
        <h3 className="font-semibold">
          {title}
        </h3>
        <small className='font-light w-full'>
          {date && moment(date.toDate()).calendar()} {user && user.firstName} {user && user.lastName && user.lastName.charAt(0)}
        </small>
        <p className="leading-tight text-justify w-full mt-3">
          {desc}
        </p>
      </div>
    </div>
  );
}

export default TimelineItem
